<template>
  <Modal
      :show.sync="isOpen"
      :on-close="onClose"
      :class="'select_product_modal'"
    >
    <div>
        <h2 class="font_regular font_600 text_20">{{$t('COUPON.SELECT_MODAL.TITLE')}}</h2>
    </div>
    <SearchInputVue
        v-model="searchValue"
        @search="onSearch"
        :placeholder="$t('COUPON.SELECT_MODAL.SEARCH.PLACEHOLDER')"
        :className="'mt_10'"
    />
    <section class="mt_20">
        <div>
            <div class="coupon">
                <div>
                    <h4 class="font_regular text_14 font_600 capitalize m_0">{{$t('COUPON.SELECT_MODAL.TABLE.NAME')}}</h4>
                </div>
                <div>
                    <p class="font_regular font_600 text_14">{{$t('COUPON.SELECT_MODAL.TABLE.CODE')}}</p>
                </div>
                <div>
                    <p class="font_regular font_600 text_14">{{$t('COUPON.SELECT_MODAL.TABLE.DISCOUNT')}}</p>
                </div>
                <div class="font_regular font_600 text_14">
                    {{$t('COUPON.SELECT_MODAL.TABLE.ACTION')}}
                </div>
            </div>
        </div>
        <ul class="coupons ml_0">
            <li v-for="(item,idx) in coupons" :key="idx">
                <div
                    class="coupon font_regular font_500 text_12 "
                    @click="onSelectItem(item)"
                >
                    <div class="cell_center_vertical">
                        <div>
                            <h4 class="font_regular text_12 font_600 capitalize m_0">{{item.name}}</h4>
                            <p class="text_10 text_black_secondary">({{item.kind}})</p>
                        </div>
                    </div>
                    <div class="cell_center_vertical">
                        <p class="font_regular font_500 text_12">{{item.code}}</p>
                    </div>
                    <div class="cell_center_vertical">
                        <p class="font_regular font_500 text_12">{{item.discount_value}} <span class="uppercase">{{item.discount_type === 'percentage' ? '%': currentAccount.currency}}</span></p>
                    </div>
                    <div>
                        <woot-button
                            variant="clear"
                            :disabled="checkedId === item.id"
                            :isLoading="checkedId === item.id"
                            @click.stop="showCouponPreview(item)"
                        >
                            {{$t('COUPON.SELECT_MODAL.BTNS.CHECK')}}
                        </woot-button>
                    </div>
                </div>
            </li>
        </ul>

        <!-- <div v-if="couponInfo" class="couponInfo_card">
            <div>
                <SHImage :src="couponInfo.image" />
            </div>
            <div class="info_details">
                <div class="info_close" @click="onCloseInfo">
                    <fluent-icon icon="dismiss" />
                </div>
                <div class="px_20 py_20">
                    <p class="font_regular font_600 text_14">{{couponInfo.promo_code}}</p>
                    <p class="font_regular font_500 text_12 mt_4">{{couponInfo.title}}</p>
                    <p class="font_regular font_500 text_12">{{couponInfo.footer}}</p>
                    <div class="mt_20">
                        <woot-button
                            @click="onAppendTemplate"
                        >
                            {{$t('COUPON.SELECT_MODAL.BTNS.ADD_TEMPLATE')}}
                        </woot-button>
                    </div>
                </div>
            </div>
        </div> -->
        <CouponPreview
            v-if="couponInfo"
            :isOpen="!!couponInfo"
            :coupon="couponInfo"
            @onClose="onCloseInfo"
        />
    </section>
    <div>
        <LoadingState
            v-if="uiFlags.isFetching" :message="$t('COUPON.SELECT_MODAL.MSG.LOADING_MSG')"
        />
        <EmptyState
            v-if="!uiFlags.isFetching && !coupons.length"
            :message="$t('COUPON.SELECT_MODAL.MSG.EMPTY_MSG')"
        />
    </div>

    <!-- <div class="mt_8">
        <woot-button
            :disabled="false"
            :isLoading="false"
            @click="onDone"
        >
            {{$t('COUPON.SELECT_MODAL.BTNS.SUBMIT_BTN')}}
        </woot-button>
    </div> -->

  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
// import Modal from '../../../../components/Modal.vue';
import Modal from 'dashboard/components/Modal.vue';
// import SearchInputVue from '../../../../../components/ui/SearchInput.vue';
import SearchInputVue from 'dashboard/components/ui/SearchInput.vue';
import SHImage from "../../../../../shopApp/routes/shop/components/SHImage.vue"
import CheckboxInput from 'dashboard/components/ui/inputs/CheckboxInput.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';
import {COUPON_STATUS,COUPON_KINDS, COUPON_REDEEM_LIST} from "./constant.coupon"
import time from '../../../../mixins/time';
import CouponApi from 'dashboard/api/coupons.js'
import CouponPreview from "./CouponPreview.vue"

export default {
    components: {
        Modal,
        SearchInputVue,
        SHImage,
        CheckboxInput,
        LoadingState,
        EmptyState,
        CouponPreview,
    },
    mixins: [alertMixin,helperMixin],
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        list:{
            type: Array,
            default: []
        },
        status_only:{
            type: String,
            required: false,
        },
        select_case:{
            type: String,
            required: false,
            validator: function (value) {
            // List of allowed values
                return [
                    'get_coupon_template',
                    'get_coupon_campaign_msg'
                ].includes(value);
            }
        },
        isDateFilter:{
            type: Boolean,
            default: true
        },
        inbox:{
            type: Object,
            required: false,
        },
    },
    computed: {
        ...mapGetters({
            currentUser: 'getCurrentUser',
            getAccount: 'accounts/getAccount',
            uiFlags: "coupons/getUIFlags",
            meta: "coupons/getMeta",
            coupons: "coupons/getCoupons",
            currentChat: 'getSelectedChat',
        }),
        currentAccount(){
            return this.getAccount(this.currentUser.account_id);
        },
        paginationCompute(){
            const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
            const isLastPage = this.meta.currentPage >= totalPages;
            const currentCount = Math.min(this.meta.currentPage * this.meta.pageSize, this.meta.count);
            const btnText = `${this.$t('CATALOGUE.PAGINATION_BTN')} (${currentCount}/${this.meta.count})`;

            return{
                isLastPage,
                btnText,
            }
        },
        checkedId(){
            return this.couponInfo?.id;
        },
    },
    data(){
        const endDate = new Date(); // Current date
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1); // One month ago
        return {
            searchValue:"",
            dateRange: [
                startDate,endDate
            ],
            selectedStatus:'',
            statusList:[
                ...COUPON_STATUS,
            ],
            type:'',
            currentSelected: null,
            couponInfo: null,
            isCouponTemplateLoading:false,
        }
    },
    mounted(){
        this.fetchItems({page:0});
    },
    methods:{
        onDone(){
            if (this.onClose) {
                this.onClose()
            }
        },
        fetchItems(query={}){
            try {
                let prepareQuery = {
                    page: query.page ?? this.meta.currentPage,
                    start_date : query.start_date ?? this.dateRange[0],
                    end_date : query.end_date ?? this.dateRange[1],
                    type: query.type?? this.type?.id,
                    status: query.status ?? this.selectedStatus?.id,
                    search: query.search ?? this.searchValue,
                }

                if (this.status_only) {
                    // only this type of status is allowed
                    prepareQuery.status = this.status_only;
                }
                if (this.isDateFilter) {
                    const {start_date,end_date} = this.formatStartEndDate(prepareQuery.start_date,prepareQuery.end_date);
                    prepareQuery = {
                        ...prepareQuery,
                        start_date: start_date.split('T')[0],
                        end_date: end_date.split('T')[0],
                    }
                }else{
                    prepareQuery.start_date = null;
                    prepareQuery.end_date = null;
                }
                this.$store.dispatch("coupons/getCoupons",this.cleanObject(prepareQuery));

            } catch (error) {
                console.log(error,error?.response);
            }
        },
        onPageChange(page,filterCategoryList=null) {
            this.fetchItems({page});
        },
        onSearch(value){
            this.fetchItems({search:value});
        },
        async onSelectItem(item){
            if (this.isCouponTemplateLoading) {
                return
            }
            switch (this.select_case) {
                case 'get_coupon_template':
                    let template = await this.getCouponTemplate(item);
                    this.onAppendTemplate(template);
                    break;
                case 'get_coupon_campaign_msg':
                    let templateItem = await this.getCouponTemplateById(item,{inbox_id:this.inbox.id});
                    this.onAppendCampaignMsg(templateItem);
                    break;

                default:
                    const index = this.list.findIndex(el=>el.id === item.id);
                    if (index < 0) {
                        this.list.push(item);
                    }else{
                        this.list.splice(index,1)
                    }
                    break;
            }
        },
        isSelected(item){
            const index = this.list.findIndex(el=>el.id === item.id);
            return index > -1;
        },
        async getCouponTemplate(item){
            try {
                this.isCouponTemplateLoading = true;
                const contact_id = this.currentChat?.meta?.sender?.id;
                const {data} = await CouponApi.getCouponCollectById(item.id,{contact_id});
                this.isCouponTemplateLoading = false;
                return data;
            } catch (error) {
                console.log(error,error?.response,"Error");
                this.isCouponTemplateLoading = false;
                this.showAlert(error?.response?.data?.error || this.$t('COUPON.SELECT_MODAL.MSG.FAIL_TEMPLATE'));
            }
        },
        async getCouponTemplateById(item,params){
            try {
                this.isCouponTemplateLoading = true;
                const {data} = await CouponApi.getCouponTemplateById(item.id,params);
                this.isCouponTemplateLoading = false;
                return data;
            } catch (error) {
                console.log(error,error?.response,"Error");
                this.isCouponTemplateLoading = false;
                this.showAlert(error?.response?.data?.error || this.$t('COUPON.SELECT_MODAL.MSG.FAIL_TEMPLATE'));
            }
        },
        async showCouponPreview(item){
            this.couponInfo = item;
        },
        onCloseInfo(){
            this.couponInfo = null;
        },
        onAppendTemplate(couponTemplate){
            this.$emit('onAppendTemplate',couponTemplate);
            this.onClose();
        },
        onAppendCampaignMsg(data){
            this.$emit('onAppendCampaignMsg',data);
            this.onClose();
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.coupons{
    position: relative;
    max-height: 56vh;
    overflow: auto;
    list-style: none;
}
.coupon{
    display: grid;
    grid-template-columns: 1fr 180px 100px 74px;
    gap: 4px;
    border-bottom: 1px solid #EEEEEE;
    padding: 6px;
    cursor: pointer;
    width: 99%;
    transition: all ease-in-out 0.2s;

    &:hover{
        transition: all ease-in-out 0.2s;
        background-color: #EEE;
    }
}

.cell_center_vertical{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
}

.couponInfo_card{
    position: absolute;
    bottom: 0;
    left: 10%;
    width: 80%;
    display: grid;
    grid-template-columns: 200px 1fr;
    background: #fff;
    box-shadow: 0 0 5px 1px #eee;
    border-radius: 10px;
}
.info_details{
    position: relative;
}
.info_close{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
</style>